(() => {
    'use strict';

    howspace.widgets.parallel = {
        initView: widget => {
            widget.find('select[name="source_widget"]').on('change', (e) => {
                widget.find('.save-btn').prop('disabled', e.currentTarget.value === '');
            });

            widget.find('.save-btn').on('click', () => {
                const sourceWidget = real.form.getDataPayload(widget).source_widget.split(':');

                const dataPayload = {
                    source_widget: {
                        type: sourceWidget[0],
                        id: sourceWidget[1]
                    }
                };

                real.ajax.json(howspace.widgets.getApiUrl(widget), {
                    type: 'POST',
                    data: JSON.stringify(dataPayload)
                });
            });
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {
            // Empty for now.
        },
        destroyEdit: widget => {
            // Empty for now.
        }
    };
})();
